import { render, staticRenderFns } from "./AddFollowUpRecord.vue?vue&type=template&id=69dc6e40&scoped=true&"
import script from "./AddFollowUpRecord.vue?vue&type=script&lang=js&"
export * from "./AddFollowUpRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dc6e40",
  null
  
)

export default component.exports